import React from 'react';

const Header = (() => {
    return (
        <div className="about-header-main">
            <div className="container">
              <div className="row about-submain align-items-center justify-content-left">
                <div className="col-md-12 col-sm-12 text-center">
                  <img className="about-banner2" src="/images/illis3.png" alt=""/>
                </div>
              </div>
            </div>
        </div>
      );
});

export default Header;
